var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tk-cover',{attrs:{"center":"","middle":"","show":_vm.show}},[_c('tk-spinner',{attrs:{"color":"white","type":"oval"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }